module.exports = __webpack_public_path__ + "img/143.2ac7ff77.gif";